import { PRODUCT_CATEGORY } from 'app/constants/Constants';
export const TRANSACTION_LIST_FIELDS: any = {
    cp: {
        transId: 'id',
        status: 'transactionState',
        clientName: 'clientName',
        dealName: 'dealName',
        product: 'transactionType',
        assetClass: 'assetClass',
        rating: 'rating',
        amount: 'humanizedIssuanceSize',
        pricing: 'discount',
        tenor: 'tenor',
        createdOn: 'createdAt',
        executionDate: 'issueDate',
    },
    ncd: {
        transId: 'id',
        status: 'transactionState',
        clientName: 'clientName',
        dealName: 'dealName',
        product: 'transactionType',
        assetClass: 'assetClass',
        rating: 'rating',
        amount: 'humanizedIssuanceSize',
        pricing: 'interest',
        tenor: 'tenor',
        createdOn: 'createdAt',
        executionDate: 'issueDate',
    },
    ncdv2: {
        transId: 'id',
        status: 'transactionState',
        clientName: 'clientName',
        dealName: 'dealName',
        product: 'transactionType',
        assetClass: 'assetClass',
        rating: 'rating',
        amount: 'humanizedIssuanceSize',
        pricing: 'interest',
        tenor: 'tenor',
        createdOn: 'createdAt',
        executionDate: 'issueDate',
    },
};

export const SORTING_DATES = [
    { label: 'Created On', value: 'created_at' },
    { label: 'Execution date', value: 'issue_date' },
];
export const SORTING_DATES_TRENDING = [
    { label: 'Created On', value: 'created_at' },
    { label: 'Execution date', value: 'issue_date' },
    { label: 'Trending Score', value: 'trending_score' },
];

export const TRANSACTION_LIST_HEADERS: {
    label: string;
    value: string;
}[] = [
    {
        label: 'Name',
        value: 'name',
    },
    {
        label: 'Product',
        value: 'product',
    },
    {
        label: 'Asset Class',
        value: 'assetClass',
    },
    {
        label: 'Rating',
        value: 'rating',
    },
    {
        label: 'Amount',
        value: 'amount',
    },
    {
        label: 'Pricing',
        value: 'pricing',
    },
    {
        label: 'Tenor',
        value: 'tenor',
    },
    {
        label: 'Execution Date',
        value: 'executionDate',
    },
];

export const TABS = {
    NEW: 'new',
    LIVE: 'live',
    RECOMMENDED: 'recommended',
    MISSED: 'missed',
    SETTLED: 'settled',
    MATURED: 'matured',
    CLIENT_PORTFOLIO: 'client_portfolio',
    RECENTLY_ADDED: 'recently_added',
    HIGH_VOLUME: 'high_volume',
    TRENDING: 'trending',
};

export const TAB_OPTIONS: {
    name: string;
    value: string;
    icon: string;
}[] = [
    { name: 'Live Deals', value: TABS.LIVE, icon: 'icon-feed' },
    { name: 'Settled Deals', value: TABS.SETTLED, icon: 'icon-deal' },
    { name: 'Matured Deals', value: TABS.MATURED, icon: 'icon-matured' },
];

export const INTERNAL_AUDITOR_TAB_OPTIONS: {
    name: string;
    value: string;
    icon: string;
}[] = [
    { name: 'Settled Deals', value: TABS.SETTLED, icon: 'icon-deal' },
    { name: 'Matured Deals', value: TABS.MATURED, icon: 'icon-matured' },
];

// export const INVESTOR_TAB_OPTIONS: {
//     name: string;
//     value: string;
//     icon: string;
//     disable?: boolean;
// }[] = [
//     { name: 'New Offers', value: TABS.NEW, icon: 'icon-shopping-label' },
//     { name: 'Recommended', value: TABS.RECOMMENDED, icon: 'icon-star' },
//     {
//         name: 'Missed Deals',
//         value: TABS.MISSED,
//         icon: 'icon-left-arrow-missed-call',
//     },
//     { name: 'Live Deals', value: TABS.LIVE, icon: 'icon-feed' },
//     { name: 'My Portfolio', value: TABS.SETTLED, icon: 'icon-deal' },
//     { name: 'Matured Deals', value: TABS.MATURED, icon: 'icon-matured' },
// ];

export const PRODUCT_VALUES = {
    all: '',
    ncd: 'Ncd::Transaction',
    cp: 'CommercialPaper::Transaction',
};

export const PRODUCT_TYPE_TABS: {
    label: string;
    value: string;
    id: string;
    description: string;
    type?: string;
}[] = [
    { value: PRODUCT_VALUES.all, label: 'ALL', id: 'all', description: 'All Products', type: 'all' },
    { value: PRODUCT_VALUES.ncd, label: 'NCD', id: 'ncd', description: 'Non Convertible Debentures', type: PRODUCT_CATEGORY.bonds },
    { value: PRODUCT_VALUES.cp, label: 'CP', id: 'cp', description: 'Commercial Paper', type: PRODUCT_CATEGORY.bonds },
];

export const PRODUCT_TYPE_TABS_FSClient: {
    label: string;
    value: string;
    id: string;
    description: string;
    type?: string;
}[] = [
    { value: PRODUCT_VALUES.all, label: 'ALL', id: 'all', description: 'All Products', type: 'all' },
    { value: PRODUCT_VALUES.ncd, label: 'NCD', id: 'ncd', description: 'Non Convertible Debentures', type: PRODUCT_CATEGORY.bonds },
    { value: PRODUCT_VALUES.cp, label: 'CP', id: 'cp', description: 'Commercial Paper', type: PRODUCT_CATEGORY.bonds },
];

export const TRANSACTION_LIST_PAGE_SIZE = 10;

export const INVESTOR_POOLS_TABS = [
    {
        title: 'EXPLORE POOLS',
        items: [
            {
                name: 'All Pools',
                icon: 'iconnew-summary',
                value: TABS.NEW,
            },
            {
                name: 'Recommended',
                icon: 'icon-star',
                value: TABS.RECOMMENDED,
            },
            {
                name: 'Portfolio Client',
                icon: 'iconnew-summary',
                value: TABS.CLIENT_PORTFOLIO,
            },
            {
                name: 'Recently Added',
                icon: 'icon-shopping-label',
                value: TABS.RECENTLY_ADDED,
            },
            {
                name: 'High Volume',
                icon: 'iconnew-summary',
                value: TABS.HIGH_VOLUME,
            },
            {
                name: 'Trending',
                icon: 'iconnew-summary',
                value: TABS.TRENDING,
            },
        ],
    },
    {
        title: 'MY DEALS',
        items: [
            {
                name: 'Live Deals',
                icon: 'icon-feed',
                value: TABS.LIVE,
            },
            {
                name: 'Matured Deals',
                icon: 'icon-matured',
                value: TABS.MATURED,
            },
            { name: 'My Portfolio', value: TABS.SETTLED, icon: 'icon-deal' },
        ],
    },
];

export const INVESTOR_LOANS_TABS = [
    {
        title: 'EXPLORE BONDS',
        items: [
            {
                name: 'All Bonds',
                icon: 'iconnew-summary',
                value: 'new',
            },
            {
                name: 'Recommended',
                icon: 'icon-star',
                value: 'bond_recommended',
            },
            {
                name: 'Long Term',
                icon: 'icon-feed',
                value: 'long_term',
            },
            {
                name: 'Short Term',
                icon: 'iconnew-summary',
                value: 'short_term',
            },
            {
                name: 'Secured',
                icon: 'iconnew-summary',
                value: 'secured',
            },
            {
                name: 'Unsecured',
                icon: 'iconnew-summary',
                value: 'unsecured',
            },
        ],
    },
    {
        title: 'MY DEALS',
        items: [
            {
                name: 'Live Deals',
                icon: 'icon-feed',
                value: TABS.LIVE,
            },
            {
                name: 'Matured Deals',
                icon: 'icon-matured',
                value: TABS.MATURED,
            },
            { name: 'My Portfolio', value: TABS.SETTLED, icon: 'icon-deal' },
        ],
    },
];

export const INVESTOR_SIDEMENUS = { [PRODUCT_CATEGORY.pools]: INVESTOR_POOLS_TABS, [PRODUCT_CATEGORY.bonds]: INVESTOR_LOANS_TABS };
